// Shared desktop right-panel width, matching the MapListBar layout.
// Keep numeric pixel units: map fitting and control offsets consume this value.
export const desktopSidebarWidth = '520px';
